module.exports = __webpack_public_path__ + "static/media/logo_sem_fundo.36b79edb.png";